<template>
  <div class="acceptance-manage-container animated fadeInRight">
    <el-row :gutter="20">
      <!-- 内容区域 -->
      <el-col :span="24">
        <!-- 查询条件 -->
        <el-card class="box-card">
          <el-row :gutter="20">
        
            	<el-col :xs="12" :sm="8" :md="6" :lg="5" :xl="4">
							<el-input v-model.trim="searchForm.orderNo"
								:placeholder="$t('repairPoolManage.workOrderCodePlaceholder')" clearable />
						</el-col>
						<el-col :xs="12" :sm="8" :md="6" :lg="5" :xl="4">
							<el-input v-model.trim="searchForm.initiatorName"
								:placeholder="$t('repairPoolManage.repairPersonPlaceholder')" clearable />
						</el-col>
                <el-col  :sm="8" :md="6" :lg="5" :xl="4">
              <el-input
                v-model="searchForm.initiatorPhone"
                placeholder="请输入手机号"
                clearable
              />
            </el-col>
            <el-col :span="4" class="flex justify-start">
              <el-button type="primary" @click="handleSearch">查询</el-button>
            </el-col>
          </el-row>
        </el-card>

        <!-- 验收单列表 -->
        <el-card class="box-card margin-top-20">
          <el-table :data="tableData" border style="width: 100%" v-loading="loading" max-height="550">
            <el-table-column
              prop="orderNo"
              label="工单编号"
              align="center"
              min-width="150"
            />
              <el-table-column
              prop="communityName"
              label="小区名称"
              align="center"
              width="120"
            />
            <el-table-column
              label="位置"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">
                {{ getLocationText(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              label="报修类型"
              align="center"
            >
              <template slot-scope="scope">
                {{ getOrderTypeText(scope.row.orderType) }}
              </template>
            </el-table-column>
          
            <el-table-column
              prop="initiatorName"
              label="报修人"
              align="center"
              width="120"
            />
            <el-table-column
              prop="initiatorPhone"
              label="联系方式"
              align="center"
              width="120"
            />
            <el-table-column
              prop="bookingTime"
              label="报修时间"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                {{ scope.row.bookingTime || '-' }}
              </template>
            </el-table-column>
			<el-table-column prop="problemDesc" label="报修内容" align="center"
				min-width="200" />
				
            <el-table-column
              prop="createTime"
              label="提交时间"
              align="center"
              min-width="150"
            />
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleDetail(scope.row)">
                  查看详情
                </el-button>
                <el-button size="mini" type="warning" @click="handleGenerateRepair(scope.row)">
                  生成验收单
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="margin-top-20"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.size"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 生成验收单组件 -->
    <preview-acceptance-form
      :visible="generateRepairDialogVisible"
      :acceptance-detail="selectedAcceptance"
      @close="closeGenerateRepairModal"
    />
  </div>
</template>

<script>
import { listAcceptanceOrders } from '@/api/work/acceptanceManageApi'
import PreviewAcceptanceForm from '@/components/work/PreviewAcceptanceForm.vue'

export default {
  name: 'AcceptanceManageList',
  components: {
    PreviewAcceptanceForm
  },
  data() {
    return {
      loading: false,
      searchForm: {
        initiatorPhone: '',
        orderNo: '',
        initiatorName: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      generateRepairDialogVisible: false,
      selectedAcceptance: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        }

        // 过滤掉空字符串、null、undefined 的参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const { data, total } = await listAcceptanceOrders(params)

        // 适配验收单字段到表格字段
        this.tableData = (data || []).map(item => {
          const statusKey = String(item.status)
          const statusMap = {
            '0': this.$t('acceptanceManage.status.pending'),
            '1': this.$t('acceptanceManage.status.processing'),
            '2': this.$t('acceptanceManage.status.completed'),
            '3': this.$t('acceptanceManage.status.rejected')
          }

          return {
            ...item,
            // 工单编号
            orderNo: item.orderNo || item.acceptanceNo || item.acceptanceId || '',
            // 报修人
            initiatorName: item.initiatorName || item.ownerName || item.acceptanceName || '',
            // 联系方式
            initiatorPhone: item.initiatorPhone || item.contactPhone || item.tel || '',
            // 状态文字
            stateName: statusMap[statusKey] || item.stateName || ''
          }
        })

        this.pagination.total = total || (this.tableData ? this.tableData.length : 0)
      } catch (error) {
        console.log('获取验收单列表失败', error)
        this.$message.error(this.$t('acceptanceManage.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    getLocationText(row) {
      if (!row) return ''
      
      // 如果是公区报修（orderType === 1），使用 addressDetail
      if (row.orderType === 1 || row.orderType === '1') {
        return row.addressDetail || ''
      }
      // 如果是室内报修（orderType === 0），组合楼栋-单元-房号
      else if (row.orderType === 0 || row.orderType === '0') {
        const building = row.floorNum || row.buildingNum || ''
        const unit = row.unitNum || ''
        const room = row.roomNum || row.roomName || ''
        
        if (building || unit || room) {
          let location = ''
          if (building) location += `${building}栋`
          if (unit) location += `${unit}单元`
          if (room) location += room
          return location || row.roomName || ''
        }
        
        return row.roomName || ''
      }
      
      // 默认情况
      return row.addressDetail || row.roomName || ''
    },
    getOrderTypeText(orderType) {
      const typeMap = {
        '0': '室内报修',
        '1': '公区报修'
      }
      return typeMap[String(orderType)] || '-'
    },
    getStatusTagType(status) {
      const s = String(status)
      const map = {
        '0': 'warning', // 待验收 - 橙色
        '1': 'primary', // 验收中 - 蓝色
        '2': 'success', // 已完成 - 绿色
        '3': 'danger' // 已驳回 - 红色
      }
      return map[s] || 'info'
    },
    handleDetail(row) {
      const id = row.id || row.acceptanceId
      this.$router.push(`/views/work/acceptanceDetail?acceptanceId=${id}`)
    },
    handleGenerateRepair(row) {
      // 直接使用列表数据打开生成维修单弹窗
      // 如果需要更详细的数据，可以在这里调用详情接口
      this.selectedAcceptance = { ...row }
      this.generateRepairDialogVisible = true
    },
    closeGenerateRepairModal() {
      this.generateRepairDialogVisible = false
      this.selectedAcceptance = null
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.acceptance-manage-container {
  padding: 20px;

  .margin-top-20 {
    margin-top: 20px;
  }
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.justify-start {
  justify-content: flex-start;
}
</style>

